import axios from "axios";
import { API_PREFIX } from "../config";

let LINK = process.env.NODE_ENV == "development" ? "" : API_PREFIX;
const instance = axios.create({
  baseURL: LINK,
  timeout: 1000,
  headers: { "X-Custom-Header": "foobar" }
});
export const fetchShareDataList = param => {
  return instance
    .get("/mk_share_pay/query", { params: param })
    .then(resp => resp.data);
};

/* 
Long id,
String andriodLink, // 安卓下载练级
String applicationTreasure, // 应用宝下载链接
String band, // 波段号
String bankAccount, // 银行账号
String wxPhone, // 微信号
String idCard, // 身份证
String iosLink, // ios 链接
String name, // 姓名
String packageNumber //渠道号
*/
export const updateShareDataById = param => {
  return instance
    .get("/mk_share_pay/update", { params: param })
    .then(resp => resp.data);
};

// Long id,
export const deleteShareDataById = param => {
  return instance
    .get("/mk_share_pay/delete", { params: param })
    .then(resp => resp.data);
};

// 上传 file
export const uploadShareExcel = file => {
  let headers = { headers: { "Content-Type": "multipart/form-data" } };
  let data = new FormData();
  data.append("file", file);
  return axios
    .post(LINK + "/mk_share_pay/import", data, headers)
    .then(resp => resp.data);
};

// 下载相关
// 上传 file
export const uploadIosNewExcel = file => {
  let headers = { headers: { "Content-Type": "multipart/form-data" } };
  let data = new FormData();
  data.append("file", file);
  return axios
    .post(LINK + "/mk_share_pay_ios/import", data, headers)
    .then(resp => resp.data);
};

/* 
date 格式 2019-02-04
*/
export const fetchIosDataList = param => {
  return instance
    .get("/mk_share_pay/data", { params: param })
    .then(resp => resp.data);
};
export const deleteIosDataByDate = param => {
  return instance
    .get("/mk_share_pay_ios/delete", { params: param })
    .then(resp => resp.data);
};
export const sendPrivateMsg = param => {
  return instance
    .get("/mk_share_pay/msg", { params: param })
    .then(resp => resp.data);
};

// id
export const forbidByID = param => {
  return instance
    .get("/mk_share_pay/ban", { params: param })
    .then(resp => resp.data);
};
export const openForbidByID = param => {
  return instance
    .get("/mk_share_pay/normal", { params: param })
    .then(resp => resp.data);
};
